import { FormGroup } from '@angular/forms';
import { AutomatedFlightData } from './automated-flight-data.model';
import { AutomatedFuelDataForm } from './automated-fuel-data-form.model';
import { AutomatedLogbookDataForm } from './automated-logbook-data-form.model';
import { AutomatedOooiDataForm } from './automated-oooi-data-form.model';

export class AutomatedFlightDataForm {
  fuel: FormGroup | null;
  logbook: FormGroup | null;
  oooi: FormGroup | null;

  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(automatedData: AutomatedFlightData) {
    if (automatedData) {
      if (automatedData.fuel) {
        this.fuel = new FormGroup(new AutomatedFuelDataForm(automatedData.fuel));
      }

      if (automatedData.logbook) {
        this.logbook = new FormGroup(new AutomatedLogbookDataForm(automatedData.logbook));
      }

      if (automatedData.oooi) {
        this.oooi = new FormGroup(new AutomatedOooiDataForm(automatedData.oooi));
      }
    }
  }
}
